import { css } from '@emotion/react';
import MetadataNvDropdown from 'courses/controllers/metadata-nv-dropdown';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import t from 'react-translate';
import { halfSpacing, quarterSpacing, threeQuartersSpacing } from 'styles/global_defaults/scaffolding';

const MetadataTags = ({
  haveErrors,
  metadataFields,
}: { haveErrors: boolean, metadataFields: any[] }) => {
  const {
    watch,
    setValue,
    control,
  } = useFormContext();
  const styles = css(`
    .tag-row {
      margin-top: ${threeQuartersSpacing}px;
      padding: 0 ${halfSpacing}px;
      width: 240px;
    }
    span {
      padding: 0 ${quarterSpacing}px;
    }
    .bs4-dropdown-menu {
      width: 100%;
    }
    .has-error {
      border-color: red !important;
    }
  `);
  const [missingRequiredMetadataFieldIds, setMissingRequiredMetadataFieldIds] = useState([]);
  const requiredFields = metadataFields.filter(field => field.required).map(field => field.id);

  const courseMetadataTags = watch('courseMetadata');

  const checkMissingRequiredFields = (courseMetadata) => {
    const missingFields = requiredFields
      .filter(fieldId => !(courseMetadata ?? [])
        .some(item => item.metadataFieldId === fieldId && item.metadataValueId));

    setMissingRequiredMetadataFieldIds(missingFields);
  };

  // Check missing required fields when haveErrors or courseMetadataTags changes
  useEffect(() => {
    if (haveErrors) {
      checkMissingRequiredFields(courseMetadataTags);
    } else {
      setMissingRequiredMetadataFieldIds([]);
    }
  }, [haveErrors, courseMetadataTags]);

  // Scroll to the first missing required field when the form is submitted with errors
  useEffect(() => {
    if (!haveErrors) return;
    if (missingRequiredMetadataFieldIds[0]) {
      document.getElementById(`metadatafield-${missingRequiredMetadataFieldIds[0]}`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [haveErrors, missingRequiredMetadataFieldIds]);

  const handleSetMetadataTags = (newTags) => {
    checkMissingRequiredFields(newTags);
    setValue('courseMetadata', newTags);
  };

  return (
    <Controller
      name='courseMetadata'
      control={control}
      render={({ field: courseMetadataField }) => (
        <div css={styles}>
          {
            metadataFields.map((field) => (
              <div
                className='tag-row'
                id={`metadatafield-${field.id}`}
                key={field.id}
              >
                <label className='gray-1-label preserve-space'>
                  {field.name}
                  {
                    field.required && (
                      <span className='text-danger'>
                        {t.COURSES.FORM.ADDITIONAL_METADATA.REQUIRED()}
                      </span>
                    )
                  }
                </label>
                <MetadataNvDropdown
                  field={field}
                  nvDropDownName={`metadataTagsDropdown_${field.id}`}
                  courseMetadataTags={courseMetadataTags}
                  setMetadataTags={(newTags) => {
                    handleSetMetadataTags(newTags);
                    courseMetadataField.onChange(newTags);
                  }}
                  showError={missingRequiredMetadataFieldIds.includes(field.id)}
                  showTooltipError={missingRequiredMetadataFieldIds[0] === field.id}
                />
              </div>
            ))
          }
        </div>
      )}
    />
  );
};

export default MetadataTags;
